import clsx from 'clsx';

import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

import type { MenuOptionItemOwnerState } from './types';

export function getMenuOptionItemUtilityClass(slot: string): string {
  return generateUtilityClass('MenuOptionItem', slot);
}

export const menuOptionItemClasses = generateUtilityClasses('MenuOptionItem', [
  // 고정 클래스 (target)
  'root',
  'content',

  // 동적 클래스 (getDynamicClasses)
  'selected',
  'disabled',
  'focused',
  'interactive',
  'colorDefault',
  'colorGlobal',
]);

/**
 * OwnerState 기반 동적 클래스 반환
 *
 * @param ownerState - 컴포넌트 상태
 * @returns 동적 클래스 문자열
 */
export function getDynamicClasses(ownerState: MenuOptionItemOwnerState): string {
  return clsx({
    [menuOptionItemClasses.selected]: ownerState.selected,
    [menuOptionItemClasses.disabled]: ownerState.disabled,
    [menuOptionItemClasses.focused]: ownerState.focused,
    [menuOptionItemClasses.interactive]: ownerState.interactive,
    [menuOptionItemClasses.colorDefault]: ownerState.color === 'default',
    [menuOptionItemClasses.colorGlobal]: ownerState.color === 'global',
  });
}
